import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "./TextOnlySongSlide.css";

export const TextOnlySongSlide = () => {
  const { t } = useTranslation();
  return (
    <div className="text-only-song">
      <div>
        <div className="p-3">
          <h1>
            <FontAwesomeIcon icon={faFileLines} />
            <br />
          </h1>
          {t("carousel.slide.noSongsheets")}
          <br />
          {t("carousel.slide.switchToLyrics")}
        </div>
      </div>
    </div>
  );
};
